import { getLocaleString, ONE_AND_ALL_NAME, POWER_MAGIC_NAME, ProductModelService, productWithProperties, propertyLabels } from "ngx-core-services";

export const prettifyProductName = (deviceValue: string | undefined, labels: propertyLabels): string => {
  if (!deviceValue) {
    return '';
  }

  switch (deviceValue) {
    case 'hybrid-3ph':
    case 'hybrid':
      return labels.hybridInverter;
    case 'pv':
      return labels.photovoltaicInverter;
    case 'evcharge':
      return labels.evCharge;
    case 'storage':
      return labels.storageInverter;
    case 'inverter':
      return labels.inverter;
    case 'evcharge':
      return labels.evCharge;
    case 'enerclic':
      return 'combox';
  }
  return deviceValue;
}

export const getProductProperties = (
  id: string,
  labels: propertyLabels,
  uiFramework: 'material' | 'ionic'
): productWithProperties | undefined => {
  const device = new ProductModelService(id);
  if (!device.type) {
    return;
  }

  const getIcon = (iconKey: string): string => {
    const iconMapping: Record<string, { material: string; ionic: string }> = {
      info: { material: 'info', ionic: 'information-circle-outline' },
      power_input: { material: 'power_input', ionic: 'battery-charging' },
      bolt: { material: 'bolt', ionic: 'flash' },
    };
    return iconMapping[iconKey][uiFramework];
  };

  switch (device.type.name) {
    case 'inverter': {
      let power = '';
      if (device.type.ratedPower) {
        power = ' ' + device.type.ratedPower / 1000 + 'kW';
      }
      return {
        product: device,
        prettyName: (
          device.isOneAndAll
            ? ONE_AND_ALL_NAME
              : device.isPowerMagic
                ? POWER_MAGIC_NAME
                : prettifyProductName(device.type?.name, labels)
        ) + power,
        properties: [
          {
            name: labels.deviceType,
            value: prettifyProductName(device.type.value, labels),
            icon: getIcon('info'),
          },
          {
            name: labels.phase,
            value:
              device.type.phase === 'three-phase'
                ? labels.threePhase
                : labels.singlePhase,
            icon: getIcon('power_input'),
          },
          ...(device.type.ratedPower
            ? [
                {
                  name: labels.ratedPower,
                  value:
                    getLocaleString(device.type.ratedPower, labels.localeCode) +
                    ' W',
                  icon: getIcon('bolt'),
                },
              ]
            : []),
        ],
      };
    }
    case 'meter': {
      return {
        product: device,
        prettyName: prettifyProductName(device.type.name, labels),
        properties: [
          {
            name: labels.deviceType,
            value: device.type.name,
            icon: getIcon('info'),
          },
        ],
      };
    }
    case 'evcharge': {
      return {
        product: device,
        prettyName: prettifyProductName(device.type.name, labels),
        properties: [
          {
            name: labels.deviceType,
            value: prettifyProductName(device.type.name, labels),
            icon: getIcon('info'),
          },
        ],
      };
    }
    case 'connext':
    case 'enerclic': {
      return {
        product: device,
        prettyName: prettifyProductName(device.type.name, labels),
        properties: [],
      };
    }
    default: {
      return {
        product: device,
        prettyName: prettifyProductName(device.type.name, labels),
        properties: [
          {
            name: labels.deviceType,
            value: device.type.name,
            icon: getIcon('info'),
          },
        ],
      };
    }
  }
};
